export const getChainIdNumber = (chainId?: number | string): number => {
  if (typeof chainId === 'undefined') {
    return 0
  }
  if (typeof chainId === 'string') {
    return parseInt(chainId, 16)
  }
  return chainId
}
